import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=3d2920c8&scoped=true&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardGroup.vue?vue&type=style&index=0&id=3d2920c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2920c8",
  null
  
)

export default component.exports